import { STORY } from "@/constants/testIds";
import { useLang } from "@/i18n/LanguageContext";
import { HydrangeaFlourish, RoseFlourish } from "@/components/wedding/Flourish";
import { Reveal } from "@/components/motion/Reveal";

export const OurStory = () => {
  const { t } = useLang();
  const heading = t("story.heading"); // array [pre, em, post]
  const timeline = t("story.timeline") || [];

  return (
    <section id="story" data-testid={STORY.section} className="relative py-24 sm:py-32 overflow-hidden">
      <HydrangeaFlourish
        className="absolute -top-6 -right-10 w-[100px] sm:w-[140px] md:w-[180px]"
        opacity={0.85}
      />
      <RoseFlourish
        className="absolute -bottom-8 -left-6 w-[100px] sm:w-[140px] md:w-[180px] rotate-3"
        opacity={0.8}
      />
      <div className="max-w-7xl mx-auto px-6 sm:px-10 grid grid-cols-1 md:grid-cols-12 gap-12">
        <Reveal className="md:col-span-5">
          <div className="sticky top-28">
            <div className="relative">
              <img
                src="https://customer-assets-cm19k8pv.emergentagent.net/job_bride-groom-hub-75/artifacts/6ujxt6b9_CLP08684%20%281%29.webp"
                alt="Carmen & Kerbert — the lift under the lights"
                className="img-art w-full aspect-[3/4] object-cover"
              />
              <a
                href="https://instagram.com/chlaaneste"
                target="_blank"
                rel="noreferrer"
                data-testid="story-photo-credit"
                className="absolute bottom-3 right-3 font-serif italic text-[11px] sm:text-xs text-white/90 hover:text-white transition-colors [text-shadow:0_1px_6px_rgba(0,0,0,0.5)]"
              >
                @chlaaneste
              </a>
            </div>
          </div>
        </Reveal>

        <div className="md:col-span-7">
          <Reveal delay={0.1}>
            <h2
              data-testid={STORY.heading}
              className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tighter font-light leading-[0.95]"
            >
              {heading[0]}
              <em className="italic">{heading[1]}</em>
              {heading[2]}
            </h2>
          </Reveal>

          <Reveal delay={0.2}>
            <div data-testid={STORY.body} className="mt-12 space-y-8 max-w-2xl font-sans text-[17px] leading-[1.75] text-black/80">
              <p className="drop-cap">{t("story.p1")}</p>
              <p>{t("story.p2")}</p>
              <p>{t("story.p3")}</p>
            </div>
          </Reveal>

          <Reveal delay={0.3}>
            <div className="mt-14 grid grid-cols-3 gap-6 max-w-xl">
              {timeline.map((m) => (
                <div key={m.y} className="border-t border-black/15 pt-4">
                  <div className="font-display text-3xl">{m.y}</div>
                  <div className="font-overline text-[10px] text-black/60 mt-1">{m.e}</div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
